import React from 'react';
import home from '../../assets/navResponsive/home.png';
import about from '../../assets/navResponsive/about.png';
import projects from '../../assets/navResponsive/projects.png';
import contact from '../../assets/navResponsive/contact.png';
import styles from './NavMobile.module.css';

const NavMobile = () => {
     return (
          <div className={styles.container}>
               <a href="#header" className={styles.header}>
                    <img src={home} alt="home" />
               </a>
               <a href="#about">
                    <img src={about} alt="about" />
               </a>
               <a href="#projects">
                    <img src={projects} alt="projects" />
               </a>
               <a href="#contact">
                    <img src={contact} alt="contact" />
               </a>
          </div>
     );
};

export default NavMobile;
